"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbLanguageSwitcher = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _isClickOutside = require("../../skybase-core/utils/is-click-outside");

var _shapes = require("../../skybase-core/shapes");

var _locales = require("../../skybase-core/locales");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _SbLanguageSwitcher = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbLanguageSwitcher, _PureComponent);

  var _super = _createSuper(_SbLanguageSwitcher);

  function _SbLanguageSwitcher(props) {
    var _this;

    _classCallCheck(this, _SbLanguageSwitcher);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var isDropDownVisible = _this.state.isDropDownVisible;

      _this.toggleDropDown(!isDropDownVisible);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var isDropDownVisible = _this.state.isDropDownVisible;
      var ignoreClasses = ['sb-modal-container', 'sb-modal', 'sb-modal-overlay'];

      if (isDropDownVisible && (0, _isClickOutside.isClickOutside)(event, _this.node, ignoreClasses)) {
        _this.toggleDropDown(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (event) {
      var onLanguageChange = _this.props.onLanguageChange;
      var languageStringId = event.target.id;
      var language = languageStringId.substring('language-switcher-selector-'.length);
      onLanguageChange(language);
    });

    _this.state = {
      isDropDownVisible: false
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(_SbLanguageSwitcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleClickOutside);
    }
    /**
     * @desc
     * Triggers when our component was unmounted. We'll unbind our clickOutside handler.
     *
     * @private
     * @method
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "getClassNameForWrapper",
    value: function getClassNameForWrapper(className) {
      return (0, _classnames.default)('sb-language-switcher', 'sb-language-wrapper', className);
    }
  }, {
    key: "toggleDropDown",
    value: function toggleDropDown(isDropDownVisible) {
      this.setState({
        isDropDownVisible: isDropDownVisible
      });
    }
  }, {
    key: "renderDropDown",
    value: function renderDropDown(isVisible, currentLanguage, languages) {
      var _this2 = this;

      return isVisible ? /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-language-buttons"
      }, languages.map(function (language) {
        var id = language.id,
            name = language.name,
            className = language.className;
        var checked = currentLanguage === id;
        var componentId = "language-switcher-selector-".concat(id);
        return /*#__PURE__*/_react.default.createElement("a", {
          id: componentId,
          onClick: _this2.handleOnChange,
          className: (0, _classnames.default)({
            checked: checked
          }, className),
          key: componentId
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "sbi-checkhook check-icon"
        }), name);
      })) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          languages = _this$props.languages,
          className = _this$props.className,
          id = _this$props.id,
          language = _this$props.language,
          style = _this$props.style;
      var isDropDownVisible = this.state.isDropDownVisible;
      var classNames = this.getClassNameForWrapper(className);
      return /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: classNames,
        style: style,
        ref: function ref(node) {
          _this3.node = node;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-status-bar-btn fl-row fl-align-items-center",
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-language"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "active-language"
      }, language.substring(0, 2).toUpperCase()), /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)('toggle-icon', {
          'sbi-chevron-down': !isDropDownVisible,
          'sbi-chevron-up': isDropDownVisible
        })
      })), this.renderDropDown(isDropDownVisible, language, languages));
    }
  }]);

  return _SbLanguageSwitcher;
}(_react.PureComponent);

_defineProperty(_SbLanguageSwitcher, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  language: _propTypes.default.string,
  languages: _propTypes.default.arrayOf(_shapes.PropTypeLanguage).isRequired,
  onLanguageChange: _propTypes.default.func.isRequired
});

_defineProperty(_SbLanguageSwitcher, "defaultProps", {
  className: null,
  id: null,
  style: null,
  language: 'en'
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var localeState = (0, _locales.getLocaleState)(state);
  return {
    language: ownProps.language || (0, _locales.getCurrentLanguage)(localeState),
    languages: ownProps.languages || (0, _locales.getLanguages)(localeState)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onLanguageChange: function onLanguageChange(value) {
      return ownProps.onLanguageChange ? ownProps.onLanguageChange(value, dispatch) : dispatch((0, _locales.setLanguage)(value));
    }
  };
};

var SbLanguageSwitcher = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SbLanguageSwitcher);
exports.SbLanguageSwitcher = SbLanguageSwitcher;
//# sourceMappingURL=sb-language-switcher.js.map